import {
  STATS_TYPES, AGGREGATION_LEVELS,
} from '@/mqtt/liveStats'
import {
  isFeatureEnabled,
  isPresentationResetAfterTurnOnFlag,
  comparePresentationCreatedDateWithFlag,
} from '../featureToggles.module'

const reactionActions = {
  subscribeReactionUpdateAction: async ({ dispatch }, { presentation }) => {
    await dispatch('fetchStatsByWildCardAction', {
      path: `${STATS_TYPES.REACTION_COUNT}/${AGGREGATION_LEVELS.PER_REACTION_TYPE}/${presentation.id}/${presentation.version}`,
    })

    dispatch('subscribeStatsAction', {
      statsType: STATS_TYPES.REACTION_COUNT,
      aggregationLevel: AGGREGATION_LEVELS.PER_REACTION_TYPE,
      identifier: presentation.id,
    })
  },

  fetchReactionsByPresentation: async ({ dispatch }, { presentation }) => {
    await dispatch('fetchStatsByWildCardAction', {
      path: `${STATS_TYPES.REACTION_COUNT}/${AGGREGATION_LEVELS.PER_REACTION_TYPE}/${presentation.id}/${presentation.version}`,
    })
  },

  canGetReactionFromAhaSyncForPresentation: ({ rootGetters }, presentation) => {
    const livestatsFlag = 'kv-sync-emqx-for-live-stats'
    return isFeatureEnabled(rootGetters, livestatsFlag)
            && (isPresentationResetAfterTurnOnFlag(presentation, livestatsFlag)
            || comparePresentationCreatedDateWithFlag(presentation, livestatsFlag))
  },
}

export default reactionActions
